module.exports = __webpack_public_path__ + "img/life@Q_grow.cdf6e4ac.jpg";